// Convert country name to ISO 3166-1 alpha-2 code -> unicode flag emoji.
// Kept in-app (no network dependency).
const COUNTRY_TO_ISO = {
  "United States": "US",
  "United Kingdom": "GB",
  "Canada": "CA",
  "Australia": "AU",
  "India": "IN",
  "Germany": "DE",
  "France": "FR",
  "Japan": "JP",
  "Brazil": "BR",
  "Mexico": "MX",
  "Spain": "ES",
  "Italy": "IT",
  "Netherlands": "NL",
  "Sweden": "SE",
  "Norway": "NO",
  "Poland": "PL",
  "South Korea": "KR",
  "Singapore": "SG",
  "United Arab Emirates": "AE",
  "South Africa": "ZA",
  "Argentina": "AR",
  "Chile": "CL",
  "New Zealand": "NZ",
};

export function isoFromCountry(country) {
  if (!country) return null;
  return COUNTRY_TO_ISO[country] || null;
}

// Convert ISO alpha-2 country code to unicode flag emoji.
export function flagEmojiFromIso(iso) {
  if (!iso || iso.length !== 2) return "🏁";
  const A = 0x1F1E6;
  const codePoints = iso.toUpperCase().split("").map(c => A + (c.charCodeAt(0) - 65));
  return String.fromCodePoint(...codePoints);
}

export function flagFromCountry(country) {
  return flagEmojiFromIso(isoFromCountry(country) || "");
}
